import * as React from "react";

import {
  NotifyMeUserExperience_Step,
  usePdpNotifyMeUserExperience,
  usePdpWishlistUserExperience,
  WishlistUserExperience_Step,
} from "../providers";

import { StepNotifyMeAddedFinal } from "./step-notify-me-added-final";
import { StepWishlistAddedFinal } from "./step-wishlist-added-final";

interface WishlistDrawerProps {}
export const WishlistDrawerFragment: React.FunctionComponent<
  WishlistDrawerProps
> = (props) => {
  const { presentingUserExperienceStep } = usePdpWishlistUserExperience();

  return (
    <React.Fragment>
      {presentingUserExperienceStep ===
        WishlistUserExperience_Step.ADDED_TO_WISHLIST_SUCCESS_SCREEN && (
        <StepWishlistAddedFinal />
      )}
      <NotifyMeDrawerFragment />
    </React.Fragment>
  );
};

export const NotifyMeDrawerFragment: React.FunctionComponent = () => {
  const { presentingUserExperienceStep } = usePdpNotifyMeUserExperience();

  return (
    <React.Fragment>
      {presentingUserExperienceStep ===
        NotifyMeUserExperience_Step.ADDED_TO_NOTIFY_ME_SUCCESS_SCREEN && (
        <StepNotifyMeAddedFinal />
      )}
    </React.Fragment>
  );
};

export const useWishlistDrawerFragment = (
  presentingUserExperienceStep: `${WishlistUserExperience_Step}`
) => {
  type GeneratedClassName =
    `pdp-wishlist-ux-${Lowercase<WishlistUserExperience_Step>}`;
  const classNameForTheDrawer = React.useMemo((): GeneratedClassName => {
    return `pdp-wishlist-ux-${presentingUserExperienceStep.toLowerCase()}` as GeneratedClassName;
  }, [presentingUserExperienceStep]);

  const value = React.useMemo(
    () => ({
      classNameForTheDrawer,
    }),
    [classNameForTheDrawer]
  );

  return value;
};

export const useNotifyMeDrawerFragment = (
  presentingUserExperienceStep: `${NotifyMeUserExperience_Step}`
) => {
  type GeneratedClassName =
    `pdp-notify-me-ux-${Lowercase<NotifyMeUserExperience_Step>}`;
  const classNameForTheDrawer = React.useMemo((): GeneratedClassName => {
    return `pdp-notify-me-ux-${presentingUserExperienceStep.toLowerCase()}` as GeneratedClassName;
  }, [presentingUserExperienceStep]);

  const value = React.useMemo(
    () => ({
      classNameForTheDrawer,
    }),
    [classNameForTheDrawer]
  );

  return value;
};
